'use client';

// Error components must be Client Components
import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { ResetPage } from './reset';
import { useRollbar } from '@rollbar/react';
import { ChunkLoadErrorFallback } from 'src/components/ErrorHandlers/ChunkLoadErrorHandler';
import { isChunkLoadError } from 'src/components/ErrorHandlers/isChunkLoadError';
export default function Error(t0) {
  const $ = _c(12);
  const {
    error,
    reset
  } = t0;
  const rollbar = useRollbar();
  let t1;
  let t2;
  if ($[0] !== error || $[1] !== rollbar) {
    t1 = () => {
      console.log("Error caught in error.tsx:", error);
      console.log("Error name:", error.name);
      console.log("Error message:", error.message);
      console.log("Is chunk error:", isChunkLoadError(error));
      if (isChunkLoadError(error)) {
        rollbar.error("Chunk Load Error - Next.js Error Boundary", error, {
          userAgent: navigator.userAgent,
          url: window.location.href,
          timestamp: Date.now()
        });
      } else {
        rollbar.error(error);
      }
    };
    t2 = [error, rollbar];
    $[0] = error;
    $[1] = rollbar;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== rollbar) {
    t3 = () => {
      const handleUnhandledRejection = event => {
        const rejectionError = event.reason;
        console.log("Unhandled rejection caught:", rejectionError);
        console.log("Rejection error name:", rejectionError?.name);
        console.log("Rejection error message:", rejectionError?.message);
        console.log("Is chunk error:", isChunkLoadError(rejectionError));
        if (isChunkLoadError(rejectionError)) {
          console.warn("Chunk load error detected:", rejectionError);
          rollbar.warning("Chunk Load Error - Unhandled Rejection", rejectionError, {
            userAgent: navigator.userAgent,
            url: window.location.href,
            timestamp: Date.now()
          });
          event.preventDefault();
          setTimeout(_temp, 1000);
        }
      };
      window.addEventListener("unhandledrejection", handleUnhandledRejection);
      return () => {
        window.removeEventListener("unhandledrejection", handleUnhandledRejection);
      };
    };
    t4 = [rollbar];
    $[4] = rollbar;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  if (isChunkLoadError(error)) {
    let t5;
    if ($[7] !== error || $[8] !== reset) {
      t5 = <ChunkLoadErrorFallback error={error} resetErrorBoundary={reset} />;
      $[7] = error;
      $[8] = reset;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t5;
  if ($[10] !== reset) {
    t5 = <ResetPage reset={reset} />;
    $[10] = reset;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp() {
  window.location.reload();
}